export default {
  Student: {
    Archive: 'Thành tích',
    Detail: 'Hồ sơ',
    FullName: 'Họ tên',
    Gender: 'Giới tính',
    DateOfBirth: 'Ngày sinh',
    DateOfBirthValue: 'Ngày sinh: {date}',
    PhoneNumber: 'Số điện thoại',
    ParentPhoneNumber: 'Số điện thoại: {phoneNumber}',
    Province: 'Tỉnh/Thành phố',
    District: 'Quận/Huyện',
    Address: 'Địa chỉ',
    ArchiveAll: 'Xem tất cả',
    Student: 'Học sinh',
    Profile: 'Hồ sơ',
    DetailProfile: 'Chi tiết hồ sơ',
    YourAccountName: 'Tên tài khoản của bạn',
    ManageAccount: 'Quản lý tài khoản',
    ParentAccount: 'Tài khoản Phụ Huynh đã liên kết với bạn',
    Submit: 'Nộp bài',
    Correct: 'Làm đúng',
    ChangeAvatar: 'Thay ảnh đại diện',
    ChoseAvatar: 'Chọn ảnh đại diện có sẵn hoặc tự tải ảnh lên',
    UploadAvatarFile: 'Tải ảnh từ máy',
    SaveAvatar: 'Lưu ảnh đại diện',
    ChangeAvatarSuccess: 'Đổi ảnh đại diện thành công',
    ChangeAvatarFail: 'Đổi ảnh đại diện thất bại',
    HaventChoseAvatar: 'Bạn chưa chọn ảnh',
    SaveProfileSuccess: 'Đã lưu thông tin hồ sơ',
    SaveProfileFail: 'Lưu thông tin hồ sơ thất bại',
    PleaseEnterInformation: 'Vui lòng nhập đủ thông tin',
    ChangePhoneNumberSuccess: 'Đổi số điện thoại thành công!',
    UsePhoneNumber: 'Từ giờ bạn có thể sử dụng số điện thoại',
    ToGetPassword: 'để lấy lại mật khẩu.',
    FromDateToDate: 'Từ {fromDate} đến {toDate}',
    Rank: 'Hạng',
    SixCharacter: 'Ít nhất 6 ký tự',
    HasLetter: 'Có ký tự chữ',
    HasNumber: 'Có ký tự số',
    StudentOrgID: 'ID trường của học sinh',
    StudentGradeID: 'ID khối của học sinh',
    SISAPCode: 'Mã SISAP',
    Male: 'Nam',
    Female: 'Nữ',
    Accumulation: 'Tích lũy',
    Star: 'sao học tập',
    AvatarFrame: 'khung ảnh đại diện',
    AvatarFrameTitle: 'Khung ảnh đại diện',
    ChangeAvatarFrame: 'Đổi khung ảnh',
    ExchangeGift: 'Đổi quà',
    CurrentHave: 'Hiện có',
    ChangeAvatarIframe: 'Thay đổi khung ảnh đại diện của bạn',
    ShowAvatarIfame: 'Khung ảnh đại diện đặc biệt',
    FrameOwned: 'Đã đổi',
    ChangeAvatarFrameSuccess: 'Đổi khung ảnh đại diện thành công',
    FrameUsing: 'Đang sử dụng',
    SetAsAvatarFrame: 'Đặt làm khung ảnh đại diện',
    HowToGetStar: 'Cách nhận sao',
    YouAreStarShortFrom: 'Bạn cần thêm <b>{star} sao học tập</b> nữa để đổi <b>Khung ảnh đại diện {name}.</b>',
    HaveNoAccumulation: 'Chưa có tích lũy',
    HaveNoStar: 'Bạn chưa nhận được sao học tập',
    LetLearn: 'Cùng tìm hiểu ',
    HowToOptainStar: 'cách nhận sao',
    Please: ' nhé!',
    ExchangeGiftHistory: 'Lịch sử đổi quà',
    WayToGetStar: 'Bạn sẽ nhận được sao học tập khi đạt được những thành tích sau:',
    RankNumber: 'Hạng {number} tại ',
    AtHonorBoard: 'bảng vinh danh HS chăm chỉ',
    SubmitExercise: 'Nộp',
    Exercise: 'bài tập',
    Ontime: 'đúng hạn',
    RedoExercise: 'Làm lại các bài tập',
    Do: 'Làm các',
    ReferenceExercise: 'bài tập tự luyện',
    Achievements: 'Thành tích',
    ApplyAvatarFrameSuccess: 'Áp dụng khung ảnh đại diện mới thành công',
    HaveNoRanking: 'Chưa có thành tích',
    WorkHard: 'Chăm chỉ',
    DoExercise: 'làm bài tập',
    ToGetRank: 'để đạt thành tích tốt hơn bạn nhé!',
    NumberWeek: 'Tuần {numberWeek}'
  }
}
